import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import IconSettingClass from '../../../../../components/settingsIcon';
import StandAloneInput from '../../../../../components/stand-alone-input';
import ToastMessage from '../../../../../components/toast';

const CountersTEReportSettings = (props) => {
    const [countersReportId, setCountersReportId] = useState('');
    const [timeEntriesReportId, setTimeEntriesReportId] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        async function getSettings() {
            let settings = await axios.get(`api/counters-te/report-settings`, {
                params: { companyShortName: props.ClientDataReducer.companyShortName }
            }).catch(error => {
                ToastMessage(error.message, "error");
            });
            if (settings?.data) {
                setCountersReportId(settings.data.countersReportId || '');
                setTimeEntriesReportId(settings.data.timeEntriesReportId || '');
            }
        }
        getSettings();
    }, []);

    async function handleSave() {
        setLoading(true);
        await axios.post('api/counters-te/save-report-settings', {
            companyShortName: props.ClientDataReducer.companyShortName,
            countersReportId,
            timeEntriesReportId
        }).catch(error => {
            ToastMessage(error.message, "error");
        });
        setLoading(false);
    };

    return (
        <Accordion>
            <AccordionSummary expandIcon={<IconSettingClass />} aria-controls="panel1a-content" id="panel1a-header">
                <Typography>Counters with Time Entries Report Settings</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <div className="report-settings-form">
                    <StandAloneInput
                        label="Counters Report ID"
                        value={countersReportId}
                        change={(e) => setCountersReportId(e)}
                    />
                    <StandAloneInput
                        label="Time Entries Report ID"
                        value={timeEntriesReportId}
                        change={(e) => setTimeEntriesReportId(e)}
                    />
                    <button
                        className="btn btn-primary"
                        onClick={handleSave}
                        disabled={loading}>
                        Save Settings
                    </button>
                </div>
            </AccordionDetails>
        </Accordion>
    );
};

const mapStateToProps = ({ ClientDataReducer }) => ({ ClientDataReducer });
export default connect(mapStateToProps, {})(CountersTEReportSettings);